import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LeftCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/LeftCircleOutlined";
import AntdIcon from "../components/AntdIcon";
var LeftCircleOutlined = function LeftCircleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftCircleOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LeftCircleOutlined.displayName = 'LeftCircleOutlined';
}
export default /*#__PURE__*/React.forwardRef(LeftCircleOutlined);